import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-info__items" }

import {
  BaseFormItem,
  BaseInput,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info-inout',
  setup(__props) {

const { formData } = storeToRefs(infoStore());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
      default: _withCtx(() => [
        _createTextVNode("开户信息")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseFormItem), {
          label: "户名",
          prop: "openName",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              type: "text",
              placeholder: "请输入",
              modelValue: _unref(formData).openName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).openName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "支行名称",
          prop: "openName",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              type: "text",
              placeholder: "请输入",
              modelValue: _unref(formData).openName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).openName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "账号",
          prop: "",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              type: "text",
              placeholder: "请输入",
              modelValue: _unref(formData).openName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).openName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "联行号",
          prop: "",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              type: "text",
              placeholder: "请输入",
              modelValue: _unref(formData).openName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).openName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开户行",
          prop: "",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              type: "text",
              placeholder: "请输入",
              modelValue: _unref(formData).openName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).openName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})